/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SigninOidcRouteImport } from './routes/signin-oidc'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedNotAvailableRouteImport } from './routes/_authenticated/not-available'
import { Route as AuthenticatedPlanningScheduleRouteImport } from './routes/_authenticated/planning/schedule'
import { Route as AuthenticatedPlanningForecastRouteImport } from './routes/_authenticated/planning/forecast'
import { Route as AuthenticatedMonitoringRealtimeProductivityRouteImport } from './routes/_authenticated/monitoring/realtime-productivity'
import { Route as AuthenticatedImprovementImprovementsRouteImport } from './routes/_authenticated/improvement/improvements'
import { Route as AuthenticatedArchivedRealtimeRouteImport } from './routes/_authenticated/archived/realtime'
import { Route as AuthenticatedAnalysisTimeRouteImport } from './routes/_authenticated/analysis/time'
import { Route as AuthenticatedAnalysisProductivityRouteImport } from './routes/_authenticated/analysis/productivity'
import { Route as AuthenticatedAdminZoneManagementRouteImport } from './routes/_authenticated/admin/zone-management'
import { Route as AuthenticatedAdminIntegrationsRouteImport } from './routes/_authenticated/admin/integrations'

const SigninOidcRoute = SigninOidcRouteImport.update({
  id: '/signin-oidc',
  path: '/signin-oidc',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedNotAvailableRoute =
  AuthenticatedNotAvailableRouteImport.update({
    id: '/not-available',
    path: '/not-available',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/not-available.lazy').then((d) => d.Route),
  )
const AuthenticatedPlanningScheduleRoute =
  AuthenticatedPlanningScheduleRouteImport.update({
    id: '/planning/schedule',
    path: '/planning/schedule',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/planning/schedule.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPlanningForecastRoute =
  AuthenticatedPlanningForecastRouteImport.update({
    id: '/planning/forecast',
    path: '/planning/forecast',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/planning/forecast.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedMonitoringRealtimeProductivityRoute =
  AuthenticatedMonitoringRealtimeProductivityRouteImport.update({
    id: '/monitoring/realtime-productivity',
    path: '/monitoring/realtime-productivity',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/monitoring/realtime-productivity.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedImprovementImprovementsRoute =
  AuthenticatedImprovementImprovementsRouteImport.update({
    id: '/improvement/improvements',
    path: '/improvement/improvements',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/improvement/improvements.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedArchivedRealtimeRoute =
  AuthenticatedArchivedRealtimeRouteImport.update({
    id: '/archived/realtime',
    path: '/archived/realtime',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/archived/realtime.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedAnalysisTimeRoute =
  AuthenticatedAnalysisTimeRouteImport.update({
    id: '/analysis/time',
    path: '/analysis/time',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/analysis/time.lazy').then((d) => d.Route),
  )
const AuthenticatedAnalysisProductivityRoute =
  AuthenticatedAnalysisProductivityRouteImport.update({
    id: '/analysis/productivity',
    path: '/analysis/productivity',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/analysis/productivity.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedAdminZoneManagementRoute =
  AuthenticatedAdminZoneManagementRouteImport.update({
    id: '/admin/zone-management',
    path: '/admin/zone-management',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/admin/zone-management.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedAdminIntegrationsRoute =
  AuthenticatedAdminIntegrationsRouteImport.update({
    id: '/admin/integrations',
    path: '/admin/integrations',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/admin/integrations.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginRoute
  '/signin-oidc': typeof SigninOidcRoute
  '/not-available': typeof AuthenticatedNotAvailableRoute
  '/admin/integrations': typeof AuthenticatedAdminIntegrationsRoute
  '/admin/zone-management': typeof AuthenticatedAdminZoneManagementRoute
  '/analysis/productivity': typeof AuthenticatedAnalysisProductivityRoute
  '/analysis/time': typeof AuthenticatedAnalysisTimeRoute
  '/archived/realtime': typeof AuthenticatedArchivedRealtimeRoute
  '/improvement/improvements': typeof AuthenticatedImprovementImprovementsRoute
  '/monitoring/realtime-productivity': typeof AuthenticatedMonitoringRealtimeProductivityRoute
  '/planning/forecast': typeof AuthenticatedPlanningForecastRoute
  '/planning/schedule': typeof AuthenticatedPlanningScheduleRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/signin-oidc': typeof SigninOidcRoute
  '/not-available': typeof AuthenticatedNotAvailableRoute
  '/': typeof AuthenticatedIndexRoute
  '/admin/integrations': typeof AuthenticatedAdminIntegrationsRoute
  '/admin/zone-management': typeof AuthenticatedAdminZoneManagementRoute
  '/analysis/productivity': typeof AuthenticatedAnalysisProductivityRoute
  '/analysis/time': typeof AuthenticatedAnalysisTimeRoute
  '/archived/realtime': typeof AuthenticatedArchivedRealtimeRoute
  '/improvement/improvements': typeof AuthenticatedImprovementImprovementsRoute
  '/monitoring/realtime-productivity': typeof AuthenticatedMonitoringRealtimeProductivityRoute
  '/planning/forecast': typeof AuthenticatedPlanningForecastRoute
  '/planning/schedule': typeof AuthenticatedPlanningScheduleRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/signin-oidc': typeof SigninOidcRoute
  '/_authenticated/not-available': typeof AuthenticatedNotAvailableRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/admin/integrations': typeof AuthenticatedAdminIntegrationsRoute
  '/_authenticated/admin/zone-management': typeof AuthenticatedAdminZoneManagementRoute
  '/_authenticated/analysis/productivity': typeof AuthenticatedAnalysisProductivityRoute
  '/_authenticated/analysis/time': typeof AuthenticatedAnalysisTimeRoute
  '/_authenticated/archived/realtime': typeof AuthenticatedArchivedRealtimeRoute
  '/_authenticated/improvement/improvements': typeof AuthenticatedImprovementImprovementsRoute
  '/_authenticated/monitoring/realtime-productivity': typeof AuthenticatedMonitoringRealtimeProductivityRoute
  '/_authenticated/planning/forecast': typeof AuthenticatedPlanningForecastRoute
  '/_authenticated/planning/schedule': typeof AuthenticatedPlanningScheduleRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/signin-oidc'
    | '/not-available'
    | '/admin/integrations'
    | '/admin/zone-management'
    | '/analysis/productivity'
    | '/analysis/time'
    | '/archived/realtime'
    | '/improvement/improvements'
    | '/monitoring/realtime-productivity'
    | '/planning/forecast'
    | '/planning/schedule'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/signin-oidc'
    | '/not-available'
    | '/'
    | '/admin/integrations'
    | '/admin/zone-management'
    | '/analysis/productivity'
    | '/analysis/time'
    | '/archived/realtime'
    | '/improvement/improvements'
    | '/monitoring/realtime-productivity'
    | '/planning/forecast'
    | '/planning/schedule'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/signin-oidc'
    | '/_authenticated/not-available'
    | '/_authenticated/'
    | '/_authenticated/admin/integrations'
    | '/_authenticated/admin/zone-management'
    | '/_authenticated/analysis/productivity'
    | '/_authenticated/analysis/time'
    | '/_authenticated/archived/realtime'
    | '/_authenticated/improvement/improvements'
    | '/_authenticated/monitoring/realtime-productivity'
    | '/_authenticated/planning/forecast'
    | '/_authenticated/planning/schedule'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  SigninOidcRoute: typeof SigninOidcRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signin-oidc': {
      id: '/signin-oidc'
      path: '/signin-oidc'
      fullPath: '/signin-oidc'
      preLoaderRoute: typeof SigninOidcRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/not-available': {
      id: '/_authenticated/not-available'
      path: '/not-available'
      fullPath: '/not-available'
      preLoaderRoute: typeof AuthenticatedNotAvailableRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/planning/schedule': {
      id: '/_authenticated/planning/schedule'
      path: '/planning/schedule'
      fullPath: '/planning/schedule'
      preLoaderRoute: typeof AuthenticatedPlanningScheduleRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/planning/forecast': {
      id: '/_authenticated/planning/forecast'
      path: '/planning/forecast'
      fullPath: '/planning/forecast'
      preLoaderRoute: typeof AuthenticatedPlanningForecastRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/monitoring/realtime-productivity': {
      id: '/_authenticated/monitoring/realtime-productivity'
      path: '/monitoring/realtime-productivity'
      fullPath: '/monitoring/realtime-productivity'
      preLoaderRoute: typeof AuthenticatedMonitoringRealtimeProductivityRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/improvement/improvements': {
      id: '/_authenticated/improvement/improvements'
      path: '/improvement/improvements'
      fullPath: '/improvement/improvements'
      preLoaderRoute: typeof AuthenticatedImprovementImprovementsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/archived/realtime': {
      id: '/_authenticated/archived/realtime'
      path: '/archived/realtime'
      fullPath: '/archived/realtime'
      preLoaderRoute: typeof AuthenticatedArchivedRealtimeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/analysis/time': {
      id: '/_authenticated/analysis/time'
      path: '/analysis/time'
      fullPath: '/analysis/time'
      preLoaderRoute: typeof AuthenticatedAnalysisTimeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/analysis/productivity': {
      id: '/_authenticated/analysis/productivity'
      path: '/analysis/productivity'
      fullPath: '/analysis/productivity'
      preLoaderRoute: typeof AuthenticatedAnalysisProductivityRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/zone-management': {
      id: '/_authenticated/admin/zone-management'
      path: '/admin/zone-management'
      fullPath: '/admin/zone-management'
      preLoaderRoute: typeof AuthenticatedAdminZoneManagementRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/integrations': {
      id: '/_authenticated/admin/integrations'
      path: '/admin/integrations'
      fullPath: '/admin/integrations'
      preLoaderRoute: typeof AuthenticatedAdminIntegrationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedNotAvailableRoute: typeof AuthenticatedNotAvailableRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedAdminIntegrationsRoute: typeof AuthenticatedAdminIntegrationsRoute
  AuthenticatedAdminZoneManagementRoute: typeof AuthenticatedAdminZoneManagementRoute
  AuthenticatedAnalysisProductivityRoute: typeof AuthenticatedAnalysisProductivityRoute
  AuthenticatedAnalysisTimeRoute: typeof AuthenticatedAnalysisTimeRoute
  AuthenticatedArchivedRealtimeRoute: typeof AuthenticatedArchivedRealtimeRoute
  AuthenticatedImprovementImprovementsRoute: typeof AuthenticatedImprovementImprovementsRoute
  AuthenticatedMonitoringRealtimeProductivityRoute: typeof AuthenticatedMonitoringRealtimeProductivityRoute
  AuthenticatedPlanningForecastRoute: typeof AuthenticatedPlanningForecastRoute
  AuthenticatedPlanningScheduleRoute: typeof AuthenticatedPlanningScheduleRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedNotAvailableRoute: AuthenticatedNotAvailableRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedAdminIntegrationsRoute: AuthenticatedAdminIntegrationsRoute,
  AuthenticatedAdminZoneManagementRoute: AuthenticatedAdminZoneManagementRoute,
  AuthenticatedAnalysisProductivityRoute:
    AuthenticatedAnalysisProductivityRoute,
  AuthenticatedAnalysisTimeRoute: AuthenticatedAnalysisTimeRoute,
  AuthenticatedArchivedRealtimeRoute: AuthenticatedArchivedRealtimeRoute,
  AuthenticatedImprovementImprovementsRoute:
    AuthenticatedImprovementImprovementsRoute,
  AuthenticatedMonitoringRealtimeProductivityRoute:
    AuthenticatedMonitoringRealtimeProductivityRoute,
  AuthenticatedPlanningForecastRoute: AuthenticatedPlanningForecastRoute,
  AuthenticatedPlanningScheduleRoute: AuthenticatedPlanningScheduleRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  SigninOidcRoute: SigninOidcRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
